import { HubConnection, HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { beUrl } from "../Constants";

// Builds the SignalR connection to the community chat hub. The JWT is stored as
// "Bearer <token>"; SignalR sends it as the ?access_token= query param (WebSockets
// can't set an Authorization header), so we hand it the bare token and the backend
// lifts it back onto the request (see the OnMessageReceived handler in Program.cs).
// withCredentials:false because auth rides on the query-string token, not cookies —
// the browser blocks a credentialed request against the API's wide-open CORS
// (Access-Control-Allow-Origin: * can't be combined with credentials).
export function createChatConnection(): HubConnection {
    return new HubConnectionBuilder()
        .withUrl(`${beUrl}/hubs/chat`, {
            accessTokenFactory: () => (localStorage.getItem("token") || "").replace(/^Bearer\s+/i, ""),
            withCredentials: false,
        })
        .withAutomaticReconnect()
        .configureLogging(LogLevel.Warning)
        .build();
}
